<div
  class="w-full max-w-5xl mx-auto flex flex-col gap-4 border border-gray-300 rounded-lg bg-white"
>
  <lib-feature-header
    title="Commission Payment"
    [isLoading]="store.loading()"
    (closeClick)="goBack()"
  >
    @if (store.payment()) {
    <span
      class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      [class]="paymentTypeClass(store.payment()!.type)"
    >
      {{ paymentTypeLabel(store.payment()!.type) }}
    </span>
    }
  </lib-feature-header>

  @if (store.error()) {
  <div class="px-4">
    <lib-error-alert [error]="store.error()" />
  </div>
  } @if (store.payment(); as payment) {
  <div class="flex flex-col gap-0 divide-y divide-gray-100">
    <!-- Payment Metadata -->
    <div class="px-4 py-4">
      <dl class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
        <div>
          <dt class="text-xs text-gray-500">Payment #</dt>
          <dd class="mt-0.5 font-mono text-sm font-medium text-gray-900">
            {{ payment.document_number }}
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Invoice</dt>
          <dd class="mt-0.5 font-mono text-sm font-medium text-gray-900">
            <a
              [routerLink]="['/commission-invoices', payment.invoice_id]"
              class="text-blue-600 hover:underline"
            >
              {{ payment.invoice_number || payment.invoice_id }}
            </a>
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Payee</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ payment.payee_name || '-' }}
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Payer</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ payment.invoice_recipient_name || '-' }}
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Payment Date</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ formatDate(payment.payment_date) }}
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Method</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ paymentMethodLabel(payment.payment_method) }}
          </dd>
        </div>

        @if (payment.payment_reference) {
        <div>
          <dt class="text-xs text-gray-500">Reference</dt>
          <dd class="mt-0.5 font-mono text-sm font-medium text-gray-900">
            {{ payment.payment_reference }}
          </dd>
        </div>
        }

        <div>
          <dt class="text-xs text-gray-500">Created</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ formatDateTime(payment.created_at) }}
          </dd>
        </div>

        @if (payment.created_by) {
        <div>
          <dt class="text-xs text-gray-500">Recorded By</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ payment.created_by }}
          </dd>
        </div>
        }
      </dl>
    </div>

    <!-- Financial Summary -->
    <div class="px-4 py-4">
      <p
        class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400"
      >
        Financial Details
      </p>
      <dl class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
        <div>
          <dt class="text-xs text-gray-500">Amount</dt>
          <dd
            class="mt-0.5 text-lg font-semibold"
            [class.text-green-700]="payment.amount_minor > 0"
            [class.text-red-700]="payment.amount_minor < 0"
            [class.text-gray-900]="payment.amount_minor === 0"
          >
            {{ formatMoney(payment.amount_minor, payment.currency) }}
          </dd>
        </div>

        <div>
          <dt class="text-xs text-gray-500">Currency</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ payment.currency }}
          </dd>
        </div>
      </dl>
    </div>

    @if (payment.notes || payment.reason) {
    <!-- Notes & Reason -->
    <div class="px-4 py-4">
      <dl class="flex flex-col gap-3">
        @if (payment.reason) {
        <div>
          <dt
            class="text-xs font-semibold uppercase tracking-wide text-gray-400"
          >
            Reason
          </dt>
          <dd class="mt-1 text-sm text-gray-900">{{ payment.reason }}</dd>
        </div>
        } @if (payment.notes) {
        <div>
          <dt
            class="text-xs font-semibold uppercase tracking-wide text-gray-400"
          >
            Notes
          </dt>
          <dd class="mt-1 text-sm text-gray-900">{{ payment.notes }}</dd>
        </div>
        }
      </dl>
    </div>
    }

    <!-- Action Buttons -->
    <div class="px-4 py-4">
      <div class="flex flex-wrap gap-3 justify-end">
        <shared-cancel-button text="Back" (cancelled)="goBack()" />
      </div>
    </div>
  </div>
  }
</div>
